import { Box } from '@mui/material';
import Typography from '../../../../../../components/Typography/Typography';
import LangEnum from '../../../../../../lang/LangEnum';
import { ClarityEvents } from '../../../../../../lib/clarity/types/clarityEvents.types';
import { withEvent } from '../../../../../../lib/clarity/utils/captureEvent.utils';
import { OrderListTestIds } from '../../../../../../utils/testIds/OrderList.testIds';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { ChangeOrderStatusModalBodyProps } from './changeOrderStatusModalBody.types';
import TextFieldWithMaxLength from './components/TextFieldWithMaxLength/TextFieldWithMaxLength';
import {
  CHANGE_ORDER_STATUS_MODAL_BODY_MAIN_TEXT_BASED_IN_TARGET_STATUS,
  CHANGE_ORDER_STATUS_MODAL_BODY_SUB_TEXT_BASED_IN_TARGET_STATUS,
} from './utils/changeOrderStatusModalBody.consts';

const ChangeOrderStatusModalBody = ({
  value,
  onChange,
  maxLength,
  targetStatus,
}: ChangeOrderStatusModalBodyProps) => {
  const { translate } = useTranslation();

  const mainTextLangEnum =
    CHANGE_ORDER_STATUS_MODAL_BODY_MAIN_TEXT_BASED_IN_TARGET_STATUS[targetStatus];
  const subTextLangEnum =
    CHANGE_ORDER_STATUS_MODAL_BODY_SUB_TEXT_BASED_IN_TARGET_STATUS[targetStatus];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {mainTextLangEnum && (
        <Typography variant="body1-regular" color="textSecondary">
          {translate(mainTextLangEnum)}
        </Typography>
      )}
      <TextFieldWithMaxLength
        multiline
        minRows={3}
        maxRows={3}
        value={value}
        variant="outlined"
        onChange={onChange}
        maxLength={maxLength}
        label={LangEnum.GLOBAL_REASON}
        inputProps={{ 'test-id': OrderListTestIds.CANCEL_OBSERVATION_INPUT }}
        onFocus={withEvent(ClarityEvents.FOCUS_ON_CHANGE_ORDER_STATUS_INPUT, () => {
          return;
        })}
      />
      {subTextLangEnum && <Typography color="primary">{translate(subTextLangEnum)}</Typography>}
    </Box>
  );
};

export default ChangeOrderStatusModalBody;
